import { FFFStorage } from '@fff-web/fff-utilities';
import pkg from '../../package.json';
import { Plans } from '../pages/constants';
import { SUBSCRIPTION_STATUS, SUBSCRIPTION } from '../pages/MyAccount/utils/user';
import { getPlanChangeCompletedEventStatusFromResponse } from './getPlanChangeCompletedEventStatusFromResponse';

export const syncDelay = (milliseconds) => {
  const start = new Date().getTime();
  let end = 0;
  while (end - start < milliseconds) {
    end = new Date().getTime();
  }
};

export const addPathPrefix = (path, { newMyAccount }) =>
  newMyAccount ? [path, `${pkg.homepage}${path}`] : [path];

export const getInitialValueFromStorage = (key, defaultValue) => {
  const data = FFFStorage.getFromStorage({ key });

  if (data && data.data) {
    return { data: data.data, loading: false, fail: false };
  }

  return { data: defaultValue, loading: false, fail: false };
};

export const getImagesStaticUrl = (url) =>
  url.startsWith('http') ? url : `${process.env.REACT_APP_STATIC_MEDIA}/images/${url}`;

export const searchToObject = (search = '') =>
  search
    .slice(1)
    .split('&')
    .map((p) => p.split('='))
    .reduce((obj, [key, value]) => ({ ...obj, [key]: value }), {});

export const makeList = (
  defaultList,
  additionalElements,
  showAdditional,
  verifyAttribute = 'check',
) => {
  if (!showAdditional) {
    return defaultList;
  }
  let list = [];
  const checkElements = defaultList.filter((de) => de[verifyAttribute]);
  const nonCheckElements = defaultList.filter((de) => !de[verifyAttribute]);
  if (showAdditional) {
    list = [...checkElements, ...additionalElements, ...nonCheckElements];
  }
  return list;
};

export const getCouponCode = (couponsApplied = []) => {
  const couponCode = couponsApplied.find(({ type }) => type === 'coupon_code') || {};
  return couponCode.code ? couponCode.code : '';
};

export const capitalizeEachWord = (string = '') =>
  string
    .split(' ')
    .map((word) => word[0] && word[0].toUpperCase() + word.toLowerCase().substr(1))
    .join(' ');

export const setDefaultPlan = (membershipStatus, lastPlan) => {
  let defaultPlan = Plans.SEASONAL;

  if (membershipStatus === SUBSCRIPTION_STATUS.expired && lastPlan) {
    defaultPlan =
      lastPlan.toUpperCase() === SUBSCRIPTION.annual.toUpperCase() ? Plans.ANNUAL : Plans.SEASONAL;
  }

  return defaultPlan;
};

export { getPlanChangeCompletedEventStatusFromResponse };
